import React from 'react';

import Grid from '@material-ui/core/Grid';
import {
  DepotCostSection
} from "../../../../../RiskProfiling/components/StepContent/components/step/ProductSelectionStepsV2/components/SummaryStep/SummaryStepV2";
import ConfirmationHeader from "./components/ConfirmationHeader";


/**
 * Displays depot type cost information (costs & conditions) for a single portfolio.
 * Shows: depot costs, transaction costs, other costs, and discount info.
 */
function CostsConditionsStep(props) {
  const {
    questions: [question],
    dataService,
  } = props;

  const portfolio = question.portfolio;

  if (!portfolio) {
    return null;
  }

  const custodian = React.useMemo(() => ({
    depot: {
      logo: portfolio.logo,
      depot: portfolio.depotType.depot,
    },
    contract: portfolio.depotType
  }), [])

  return (
    <Grid container spacing={2}>
      <ConfirmationHeader />
      <DepotCostSection custodian={custodian} />
    </Grid>
  );
}

export default CostsConditionsStep;
